import { FetcherResult } from "../../api-client/fetcher";
import { ModifiedSWRResponse } from "../../api-client/useSwrGet";
import {
  DealerCartRoute,
  DealerOrderPrintRoute,
  DealerOrderReviewRoute,
  DealerWishlistPrintRoute,
} from "../../navigation/DealerRoutes";
import { useSomeParams } from "../../navigation/useSomeParams";
import { useGetCartContents } from "../../queries/useGetCartContents";
import { useGetDealerOrder } from "../../queries/useGetDealerOrder";
import { OrderDetails } from "../../stores/slices/cartSlice";

type Result<Payload, IsOrder extends boolean> = ModifiedSWRResponse<
  FetcherResult<Payload>,
  Payload
> & { isOrder: IsOrder };

export type OrderDetailsPayload =
  | Result<OrderDetails, false>
  | Result<OrderDetails, true>;

export const useOrderDetails = (): OrderDetailsPayload => {
  const params = useSomeParams(
    DealerCartRoute,
    DealerWishlistPrintRoute,
    DealerOrderReviewRoute,
    DealerOrderPrintRoute
  );

  const cartData = useGetCartContents(params?.cartId);
  const orderData = useGetDealerOrder(params?.orderNumber);

  if (params?.orderNumber) {
    return { ...orderData, isOrder: true };
  }

  return { ...cartData, isOrder: false };
};
